<template>
  <div class="d-flex align-center">
    <div class="position-absolute bg-white font-12 px-1 ml-2">{{ legenda }}</div>
    <v-divider />
    <div class="position_absolute">
      <slot name="lado-direito" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DivisorComLegenda",
  props: {
    legenda: String
  }
}
</script>

<style scoped>

</style>
